import { CommonModule } from '@angular/common';
import { AfterViewInit, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CoreService } from 'src/app/services/core.service';

@Component({
  selector: 'app-branding',
  standalone: true,
  imports: [RouterModule, CommonModule],
  template: `
    <div id="myDiv" class="branding d-none d-lg-flex align-items-center">
      <a [routerLink]="['/']" class="d-flex">
        <img *ngIf="!(options.sidenavCollapsed && options.navPos !== 'top')"
          src="./assets/images/logos/sunriseIconWhite.png"
          class="align-middle m-2"
          alt="logo"
          style="height: 45px;"
        />
        <img *ngIf="(options.sidenavCollapsed && options.navPos !== 'top')"
          src="./assets/images/logos/sunriseIconWhite2.png"
          class="align-middle m-2"
          alt="logo"
          style="height: 23px;"
        />
      </a>
    </div>
  `,
})
export class BrandingComponent {
  options = this.settings.getOptions();
  private resizeObserver!: ResizeObserver;
  divWidth: number;

  constructor(private settings: CoreService) { }

  }
